// ===============================
// Constants & Helpers
// ===============================
const FILTER_KEY_MAP = {
  'product_product_custom': 'filter.p.m.custom.product',
  'product_style_sub_product_custom': 'filter.p.m.custom.style_sub_product',
  'product_Polish': 'filter.v.option.polish',
  'product_Color': 'filter.v.m.custom.color',
  'product_metal_custom': 'filter.p.m.custom.metal',
};

const getPrevBtn = () => document.querySelector('.Previous-btn');

const normalizeFilterKey = (rawKey) =>
  rawKey?.startsWith?.('filter.') ? rawKey : (FILTER_KEY_MAP[rawKey] || null);

const buildQueryFromFilters = (filtersObj) => {
  const params = new URLSearchParams();
  for (const rawKey in filtersObj) {
    const key = normalizeFilterKey(rawKey);
    if (!key) continue;
    [...new Set(filtersObj[rawKey])].forEach(v => params.append(key, v));
  }
  params.append('sort_by', 'manual');
  return params.toString();
};

// Tiny waiter (used by auto-start)
function waitFor(testFn, { interval = 150, timeout = 7000 } = {}) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    const id = setInterval(() => {
      try {
        if (testFn()) {
          clearInterval(id);
          resolve(true);
        } else if (Date.now() - start > timeout) {
          clearInterval(id);
          reject(new Error('waitFor: timeout'));
        }
      } catch (e) {
        clearInterval(id);
        reject(e);
      }
    }, interval);
  });
}

// ===============================
// Global State
// ===============================
let currentApi = "product-finder";
let currentIndex = 1;
let jewelleryFinderIndex = 0;
let currentFilter = '';
let collectionDataString;
let filtersToPut = {};
let appliedFilter = {};
let apiCalled = {};
let isJewelleryFilter = {};
let currentTileName = [];

// ===============================
// Auto-start if referrer is homepage
// ===============================
function autoStartIfFromHome() {
  const origin = window.location.origin;
  const ref = document.referrer || '';

  // Direct land (no referrer) or external referrer → show Step 1 (do nothing)
  if (!ref || !ref.startsWith(origin)) {
    // keep Step 1; only campaign/direct traffic should see the first flow
    return;
  }

  // Internal page (not homepage) → auto-start (show Step 2 + dispatch click)
  jQuery('.find_step1').hide();
  jQuery('.find_step2').show();

  waitFor(() =>
    document.querySelector('.start_find_btn_submit') &&
    typeof window.firstApiCall === 'function'
  ).then(() => {
    const btn = document.querySelector('.start_find_btn_submit');
    if (btn) {
      const evt = new MouseEvent('click', { bubbles: true, cancelable: true });
      btn.dispatchEvent(evt);
    }
  }).catch((e) => console.warn('Auto-start skipped:', e.message));
}


if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', autoStartIfFromHome);
} else {
  autoStartIfFromHome();
}

// ===============================
// Event: Start button (delegated)
// ===============================
jQuery(document).on("click", ".start_find_btn_submit", () => {
  if (typeof clevertap !== 'undefined' && clevertap?.event?.push) {
    clevertap.event.push("Jewellery Finder Started");
  }
  if (typeof showLoader === 'function') showLoader();

  // Ensure currentApi is defined before use
  if (typeof firstApiCall === 'function') {
    firstApiCall(currentApi);
  }
});

// ===============================
// Event: Next button (delegated)
// ===============================
jQuery(document).on("click", ".Next-btn", async function () {
  if (typeof showLoader === 'function') showLoader();

  const previousBtn = getPrevBtn();
  if (previousBtn) previousBtn.style.visibility = currentIndex !== 1 ? 'visible' : 'hidden';

  const selectedRadio = jQuery(".find_check_option [name='find_radio_btn']:checked");
  const selectedSearchString = selectedRadio.data('searchstring');
  const selectedScreenName = selectedRadio.data('screenname');
  const selectedCollectionId = selectedRadio.data('collectionid');
  const selectedfilterKey = selectedRadio.data('filterkey');
  currentTileName.push(selectedRadio.data('tilename'));

  const selectedCheckboxes = jQuery(".find_check_option [name='find_checkbox_btn']:checked");

  // ✅ Collect checkbox-based filters
  if (selectedCheckboxes.length > 0) {
    // ensure keys exist
    selectedCheckboxes.each(function () {
      const key = jQuery(this).data('filterkey');
      const normalizedKey = normalizeFilterKey(key);
      if (!normalizedKey) return;
      if (!filtersToPut[normalizedKey]) filtersToPut[normalizedKey] = [];
      if (!appliedFilter[currentFilter]) appliedFilter[currentFilter] = [];
    });

    selectedCheckboxes.each(function () {
      const id = jQuery(this).data('collectionid');
      const key = jQuery(this).data('filterkey');
      const normalizedKey = normalizeFilterKey(key);
      if (!normalizedKey) return;

      currentTileName.push(id);

      filtersToPut[normalizedKey] = [...new Set([...(filtersToPut[normalizedKey] || []), id])];
      appliedFilter[currentFilter] = [...new Set([...(appliedFilter[currentFilter] || []), id])];
    });

    if (currentIndex >= 2 && typeof clevertap !== 'undefined' && clevertap?.event?.push) {
      const questionNumber = currentIndex - 1;
      clevertap.event.push(`Jewellery Finder_Q${questionNumber}_Clicked`, {
        "Tile Name": currentTileName.filter(name => name && String(name).trim() !== "").join(", ")
      });
      currentTileName.length = 0;
    }
  }

  // ✅ Handle radio-based StaticPage or JewelleryFinderHandle
  if (selectedSearchString && selectedScreenName) {
    currentApi = selectedSearchString;

    if (currentIndex >= 2 && typeof clevertap !== 'undefined' && clevertap?.event?.push) {
      const questionNumber = currentIndex - 1;
      clevertap.event.push(`Jewellery Finder_Q${questionNumber}_Clicked`, {
        "Tile Name": currentTileName.join(", ")
      });
      currentTileName.length = 0;
    }

    if (selectedScreenName === 'StaticPage') {
      await firstApiCall(currentApi);
    } else if (selectedScreenName === 'JewelleryFinderHandle') {
      await firstApiCall(currentApi, false, true);
      collectionDataString = await wizzyFilterSearch(selectedSearchString);
      const collectionCards = collectionDataString?.filters?.find?.(item => item.key === currentFilter)?.data || [];
      updateShopifyCards(collectionCards, selectedSearchString);
    }

  // ✅ Handle radio-based Shopify filter (single option)
  } else if (selectedCollectionId) {
    const normalizedKey = normalizeFilterKey(selectedfilterKey);
    if (normalizedKey) {
      filtersToPut[normalizedKey] = [...new Set([...(filtersToPut[normalizedKey] || []), selectedCollectionId])];
      appliedFilter[currentFilter] = [...new Set([...(appliedFilter[currentFilter] || []), selectedCollectionId])];
    }

    if (this.classList.contains('final-call')) {
      const queryString = buildQueryFromFilters(filtersToPut);
      window.location.href = `/collections/${encodeURIComponent(currentApi)}?${queryString}`;
    } else {
      await firstApiCall(currentApi, false, true);
      collectionDataString = await wizzyFilterSearch(currentApi);
      const collectionCards = collectionDataString?.filters?.find?.(item => item.key === currentFilter)?.data || [];
      updateShopifyCards(collectionCards, currentApi);
    }

  // ✅ No radio/collectionId — likely final filter screen
  } else {
    if (this.classList.contains('final-call')) {
      const queryString = buildQueryFromFilters(filtersToPut);
      window.location.href = `/collections/${encodeURIComponent(currentApi)}?${queryString}`;
    } else {
      await firstApiCall(currentApi, false, true);
      collectionDataString = await wizzyFilterSearch(currentApi);
      const collectionCards = collectionDataString?.filters?.find?.(item => item.key === currentFilter)?.data || [];
      updateShopifyCards(collectionCards, currentApi);
    }
  }
});

// Checkbox visual state
jQuery(document).on("change", "[name='find_checkbox_btn']", function () {
  jQuery(this).closest('.find_check_option').toggleClass('selected', this.checked);
});

// ===============================
// Event: Previous button (delegated)
// ===============================
jQuery(document).on("click", ".Previous-btn", async function () {
  if (typeof showLoader === 'function') showLoader();

  const previousBtn = getPrevBtn();
  const isJewelleryFilterCheck = previousBtn?.getAttribute('data-currentfilter');

  if (jewelleryFinderIndex !== 0) jewelleryFinderIndex = Math.max(0, jewelleryFinderIndex - 2);
  if (jewelleryFinderIndex === 0 && previousBtn) previousBtn.removeAttribute('data-currentFilter');

  // Remove last recorded step by index instead of relying on object order
  delete apiCalled[currentIndex - 1];
  currentIndex -= 2;

  if (previousBtn) previousBtn.style.visibility = currentIndex !== 1 ? 'visible' : 'hidden';

  currentApi = apiCalled[currentIndex];

  if (isJewelleryFilterCheck) {
    await firstApiCall(currentApi, false, true, true);
    collectionDataString = await wizzyFilterSearch(currentApi);
    const collectionCards = collectionDataString?.filters?.find?.(item => item.key === currentFilter)?.data || [];
    updateShopifyCards(collectionCards);
  } else {
    firstApiCall(currentApi, false, false, true);
  }
});

// ===============================
// Main API Call
// ===============================
async function firstApiCall(currentApi, isSecondCall = false, isJewelleryFinder = false, isReverse = false) {
  const url = `${window.apiUrl}/callback/static-page/${currentApi}`;

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();

    jQuery('.find_step1').hide();
    jQuery('.find_step2').show();

    apiCalled[currentIndex] = currentApi;

    const col = data?.[0]?.collections?.[0];
    if (!col) {
      if (typeof closeLoader === 'function') closeLoader();
      return data;
    }

    const filters = col.filters || [];
    const collectionItem = col;

    if (isJewelleryFinder) {
      updateDetails(filters, true, isReverse);
    } else if (!isSecondCall) {
      updateDetails(filters[0] || {}, false, isReverse);
    } else {
      updateCards(collectionItem.collectionItem || []);
    }
    return data;
  } catch (error) {
    console.error('Error fetching data:', error);
    return null;
  }
}

// ===============================
// Update UI: filters / steps
// ===============================
const updateDetails = (filters, isJewelleryFinderFlow, isReverse) => {
  const updateHeader = (title, description) => {
    const questionTitle = `
      <div class="find-content-header">
        <p>${title || ""}</p>
        <h2>${description || ""}</h2>
      </div>`;
    jQuery(".find-content-header").replaceWith(questionTitle);
  };

  const toggleProgressStep = (index, isActive) => {
    const li = document.querySelector(`.rd_progress_${index}`);
    if (li) li.classList.toggle('active', !!isActive);
  };

  // --- Simple (non-Jewellery Finder) step ---
  if (!isJewelleryFinderFlow) {
    const stepIndex = isReverse ? currentIndex + 1 : currentIndex;
    const stepElement = document.querySelector(`.rd_progress_${stepIndex}`);
    const stepLabel = document.querySelector(`.rd_progress_${stepIndex} p`);

    if (isReverse) {
      stepElement?.classList?.remove('active');
    } else {
      if (stepLabel && filters?.label) stepLabel.textContent = filters.label;
      stepElement?.classList?.add('active');
    }

    updateHeader(filters?.title, filters?.description);
    firstApiCall(currentApi, true, false, isReverse);
    return;
  }

  // --- Jewellery Finder flow ---
  const progressUl = document.querySelector('.rd_progress_main_ul');

  if (isReverse) {
    toggleProgressStep(currentIndex + 1, false);
    document.querySelector('.Next-btn')?.classList?.remove('final-call');
  } else {
    toggleProgressStep(currentIndex, true);
  }

  // First time: render all steps
  if (jewelleryFinderIndex === 0 && Array.isArray(filters)) {
    filters.forEach((step, index) => {
      const liClass = `rd_progress_${currentIndex + index}`;
      let liElement = document.querySelector(`.${liClass}`);
      if (!liElement) {
        liElement = document.createElement('li');
        liElement.className = liClass;
        liElement.innerHTML = `<span></span><p>${step?.label || ""}</p>`;
        progressUl?.appendChild(liElement);
      } else {
        liElement.querySelector('p').textContent = step?.label || "";
      }
    });

    // Clean extra steps beyond current flow
    const allLi = document.querySelectorAll('.rd_progress_main_ul li');
    allLi.forEach((li, idx) => {
      if (idx >= currentIndex - 1 + filters.length) li.remove();
    });
  }

  const currentStep = Array.isArray(filters) ? filters[jewelleryFinderIndex] : null;

  if (isReverse && jewelleryFinderIndex !== 0) {
    const prevStep = filters?.[jewelleryFinderIndex - 1];
    if (prevStep?.navigation?.searchString) {
      const previousBtn = getPrevBtn();
      previousBtn?.setAttribute('data-currentFilter', prevStep.navigation.searchString);
    }

    // Remove last entries from filtersToPut/appliedFilter
    const removeLastKey = (obj) => {
      const keys = Object.keys(obj);
      if (keys.length > 0) delete obj[keys[keys.length - 1]];
    };
    removeLastKey(filtersToPut);
    removeLastKey(appliedFilter);
  }

  if (currentStep?.title || currentStep?.description) {
    updateHeader(currentStep?.title, currentStep?.description);
  }

  currentFilter = currentStep?.navigation?.searchString || currentFilter;

  if (jewelleryFinderIndex !== 0) {
    const previousBtn = getPrevBtn();
    previousBtn?.setAttribute('data-currentFilter', currentFilter);
    isJewelleryFilter[currentIndex] = currentFilter;
  }

  jewelleryFinderIndex++;

  const progressBarCount = document.querySelectorAll('.rd_progress_main_ul li').length;
  if (currentIndex === progressBarCount) {
    document.querySelector('.Next-btn')?.classList?.add('final-call');
  }
};

// ===============================
// Renderers
// ===============================
const updateCards = (collectionCards) => {
  const cardsHTML = (collectionCards || []).map((item, index) => `
    <div class="find-content-box find_check_option">
      <input type="radio" name="find_radio_btn"
        ${index === 0 ? "checked" : ""}
        data-screenName="${item?.navigation?.screenName || ""}"
        data-searchString="${item?.navigation?.searchString || ""}"
        data-tileName="${item?.text3 || ""}">
      <label>
        <div class="img">
          <img loading="eager" fetchpriority="high" src="${item?.images?.[0].url || ""}" alt="${item?.reference || ""}">
        </div>
        <h2>${item?.text3 || ""}</h2>
      </label>
    </div>
  `).join('');

  jQuery(".find-content-box-main").html(cardsHTML);

  const selectedCard = document.querySelector(".find-content-box-main input[name='find_radio_btn']:checked")?.closest(".find-content-box");
  if (selectedCard) selectedCard.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });

  if (typeof closeLoader === 'function') closeLoader();
  currentIndex++;
};

const updateShopifyCards = (collectionCards, currentApiEnd) => {
  const cardsHTML = (collectionCards || []).map((item) => {
    const imageHandle = (item?.label || "").toLowerCase().replace(/\s+/g, '-');
    return `
      <div class="find-content-box find_check_option">
        <input type="checkbox" name="find_checkbox_btn"
          data-collectionId="${item?.key || ""}" 
          data-filterkey="${currentFilter}">
        <label>
          <div class="img">
            <img loading="eager" fetchpriority="high"
              src="https://kushals-cms-static-new.s3.ap-south-1.amazonaws.com/kushalsMobile/jewelleryFinder/${(currentApiEnd || '') + '-' + imageHandle}.png"
              alt="${item?.label || ""}">
          </div>
          <h2>${item?.label || ""}</h2>
        </label>
      </div>
    `;
  }).join('');

  jQuery(".find-content-box-main").html(cardsHTML);

  const selectedCard = document.querySelector(".find-content-box-main input[name='find_checkbox_btn']:checked")?.closest(".find-content-box");
  if (selectedCard) selectedCard.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });

  if (typeof closeLoader === 'function') closeLoader();
  currentIndex++;
};

// ===============================
// Wizzy filter API
// ===============================
const wizzyFilterSearch = async (collectionHandle) => {
  try {
    const response = await fetch(`${window.apiUrl}/callback/wizzy-filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        key: "",
        handle: collectionHandle,
        pageNo: 1,
        sizes: [],
        attributes: Object.keys(appliedFilter).length > 0 ? appliedFilter : {},
        sort: [],
      }),
    });

    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    return await response.json();
  } catch (error) {
    console.error('Error fetching wizzy filter:', error);
    return null;
  }
};
